import type { RootState } from "../types";

export const selectCardLinkedOffersEnrollment = (state: RootState) =>
  state.cardLinkedOffers.enrolled;

export const selectRecommendedCardLinkedOffers = (state: RootState) =>
  state.cardLinkedOffers.recommendedOffers;

export const selectAllCardLinkedOffers = (state: RootState) =>
  state.cardLinkedOffers.offers;

export const selectCardLinkedOfferCategories = (state: RootState) =>
  state.cardLinkedOffers.categories;

export const selectCardLinkedOfferHistory = (state: RootState) =>
  state.cardLinkedOffers.offerHistory;

export const selectCardLinkedOfferCardId = (state: RootState) =>
  state.cardLinkedOffers.selectedCardId;
